import { Component } from '@angular/core';

@Component({
    selector: 'post-login-layout-skeleton',
    templateUrl: './post-login-layout-skeleton.component.html',
    styleUrls: ['./post-login-layout-skeleton.component.scss'],
    standalone: false
})
export class PostLoginLayoutSkeletonComponent {

}
